import React from 'react';
import { views } from './constants';
import List from './List';

export default function OrganisationList() {
  return <List view={views.organisations} />;
}
